import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';

const maxAge = 300000;

@Injectable({
  providedIn: 'root'
})
export class RequestCacheService {
  cache = new Map();

  get<T>(req: HttpRequest<T>): HttpResponse<T> | undefined {
    const cachedTrue = req.headers.has('cache');
    const url = req.urlWithParams;
    const cached = this.cache.get(url);

    if (!cached || !cachedTrue) {
      return undefined;
    }

    return cached.response;
  }

  put<T>(req: HttpRequest<T>, response: HttpResponse<T>): void {
    const url = req.url;
    const entry = { url, response, lastRead: Date.now() };
    this.cache.set(url, entry);

    const expired = Date.now() - maxAge;
    this.cache.forEach(expiredEntry => {
      if (expiredEntry.lastRead < expired) {
        this.cache.delete(expiredEntry.url);
      }
    });
  }
}

